import React from "react";
import { observer } from "mobx-react-lite";
import { TSummaryEventData } from "../../store/defectRegister";

import "./index.scss";
interface IBreachAnalytics extends TSummaryEventData {
  mode: "vert" | "horz";
}

const BreachAnalytics: React.FC<IBreachAnalytics> = observer(
  ({
    defectTotalCount,
    notEliminatedDefectCount,
    deadlineViolatedDefectCount,
    eliminatedDefectCount,
    mode,
  }) => {
    const bodyClassName =
      mode === "vert"
        ? "breach-analytics__body"
        : "breach-analytics__body-horz";

    return (
      <div className={bodyClassName}>
        <div className="breach-analytics__item-wrap analytic_color1">
          <div className="breach-analytics__item">
            <div className="breach-analytics__item-left">Всего нарушений</div>
            <div className="breach-analytics__item-right">
              {defectTotalCount}
            </div>
          </div>
        </div>

        <div className="breach-analytics__item-wrap analytic_color2">
          <div className="breach-analytics__item">
            <div className="breach-analytics__item-left">
              Неустраненные нарушения
            </div>
            <div className="breach-analytics__item-right">
              {notEliminatedDefectCount}
            </div>
          </div>
        </div>

        <div className="breach-analytics__item-wrap analytic_color3">
          <div className="breach-analytics__item">
            <div className="breach-analytics__item-left">
              Нарушены cроки устранения
            </div>
            <div className="breach-analytics__item-right">
              {deadlineViolatedDefectCount}
            </div>
          </div>
        </div>

        <div className="breach-analytics__item-wrap analytic_color4">
          <div className="breach-analytics__item">
            <div className="breach-analytics__item-left">
              Устраненные нарушения
            </div>
            <div className="breach-analytics__item-right">
              {eliminatedDefectCount}
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default BreachAnalytics;
